<template>
	<div class="main-containter" v-title data-title="和华利盛">
		<FHeader :checkId="26"></FHeader>
		<!-- <FOtherBanner :name1="'关于我们'" :name2="'About Us'"></FOtherBanner> -->
		<!-- <FTitle></FTitle> -->
		<article ref="article" :style="{height:'1000px'}">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/professional' }">专业人员</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black">详情</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;display:flex">
				<div style="float: left;width: 75%;margin-right: 10%;max-width: 300px;">
					<div style="width: 100%;">
						<img style="width: 100%;" :src="item.image">
					</div>
					<div style="margin-top: 20px;height: 35px;">
						<span style="font-size: 26px;color: #98273A;">{{item.name}}</span>
						<span style="font-size: 14px;margin-left: 5px;color: #333333;">/{{item.relationship_name}}</span>
					</div>
					<div style="font-size: 14px;margin-top: 25px;color: #333333;">
						<span>邮件：{{item.email}}</span>
					</div>
					<div style="font-size: 14px;margin-top: 25px;color: #333333;">
						<span>电话：{{item.phone}}</span>
					</div>
					<div style="font-size: 14px;margin-top: 25px;color: #333333;">
						<span>地点：{{item.company_address}}</span>
					</div>
				</div>
				<div style="float:right;min-width:calc(100% - 300px)">
					<div style="font-size: 18px;color: #98273A;margin-bottom: 20px;">执业领域</div>
					<div style="font-size: 14px;color: #333333;padding-bottom: 20px;border-bottom: 1px solid #D7D7D7;">{{item.practice_areas}}</div>
					<div style="font-size: 18px;color: #98273A;margin-bottom: 20px;margin-top:20px;">执业经验</div>
					<div style="font-size: 14px;color: #333333;padding-bottom: 20px;border-bottom: 1px solid #D7D7D7;">{{item.practicing_experience}}</div>
					<div style="font-size: 18px;color: #98273A;margin-bottom: 20px;margin-top:20px;">教育背景</div>
					<div style="font-size: 14px;color: #333333;padding-bottom: 20px;border-bottom: 1px solid #D7D7D7;">{{item.educational_background}}</div>
					<div style="font-size: 18px;color: #98273A;margin-bottom: 20px;margin-top:20px;">工作经历</div>
					<div style="font-size: 14px;color: #333333;padding-bottom: 20px;border-bottom: 1px solid #D7D7D7;">{{item.work_experience}}</div>
					<div style="font-size: 18px;color: #98273A;margin-bottom: 20px;margin-top:20px;">社会职务</div>
					<div style="font-size: 14px;color: #333333;padding-bottom: 20px;border-bottom: 1px solid #D7D7D7;">{{item.social_position}}</div>
					<div style="font-size: 18px;color: #98273A;margin-bottom: 20px;margin-top:20px;">工作语言</div>
					<div style="font-size: 14px;color: #333333;padding-bottom: 20px;">{{item.working_language}}</div>
				</div>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeaderDetail.vue"
	import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue';
	// import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {queryDetail} from "@/api/lawyer";
	export default {
		name: "Index",
		
		components: {
			FHeader,
			// FOtherBanner,
			Footer
		},
		data() {
			return {
				item: {},
				lawyerList: [],
				previewBoxHeight:375
			}
		},//decodeURIComponent(
		created() {
			this.id = this.$route.query.id
			this.queryDetail()
		},
		mounted() {
			this.id = this.$route.query.id
			this.queryDetail()
		},
		activated(){
			this.id = this.$route.query.id
			this.queryDetail()
		},
		methods: {
			queryDetail(){
				let param = {}
				param.id = this.id
				queryDetail(param).then(data => {
						this.item = data.data
						console.log(this.item)
					}).catch(error => {
						this.$message.error(error)
				})
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">

	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
</style>
